import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import apiClient from 'enrollment-platform/api/enrollment-platform-client/api-client'
import {
  GetFundingBerRequestDto,
  FundingBerResponseDto,
} from './dto/funding-ber.dto'

export const getFundingBer = async (
  request: GetFundingBerRequestDto
): Promise<FundingBerResponseDto> => {
  const response = await apiClient.get<FundingBerResponseDto>(
    '/funding-invoice/benefit-effective-report',
    { params: request }
  )
  return response.data
}

export const useGetFundingBer = (
  request: GetFundingBerRequestDto,
  options?: Omit<
    UseQueryOptions<FundingBerResponseDto, Error, FundingBerResponseDto>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<FundingBerResponseDto, Error, FundingBerResponseDto>({
    queryKey: ['funding-ber', request],
    queryFn: () => getFundingBer(request),
    enabled: !!request.clientPublicKey,
    ...options,
  })
}
